<form [formGroup]="form" (ngSubmit)="submitEvent($event)">
    <p-card *ngIf="rq&&fields&&fields.length>0; else nodata" header="{{rq.nombre}}">
        <div class="p-fluid">
            @for (field of fields; track field) {
                <div class="field">
                    <rq-form-field [field]="field" [form]="form"></rq-form-field>
                </div>
            }
            @if (payLoad) {
                <div class="field">
                    <strong>Saved:</strong><br>{{ payLoad.length }}
                </div>
            }
        </div>
        <ng-template pTemplate="footer">
            <div class="flex gap-3 mt-1">
                <ng-container
                    *ngTemplateOutlet="onSubmitTemplate; context: {$implicit: rq, clickEvent: submitEvent.bind(this), formInvalid: form.invalid}">
                </ng-container>

            </div>
        </ng-template>
    </p-card>
    <ng-template #nodata>
        <div class="field">
            <div class="text-small" style="color:red">{{ rq.nombre }}</div>
            <div class="text-small" style="color:red">Formulario sin campos</div>
        </div>
    </ng-template>
</form>
